import React from 'react';
import ServiceMain from './ServiceMain';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';

const Service = () => {
    return (
        <>
            <Header 
                parentMenu='service'
                headerClass="header__area header__transparent-2 header-width header-bg-color-2 header__mlr header__mt"
            />
            <div id="smooth-wrapper">
                <div id="smooth-content">
                    <ServiceMain />
                    <Footer />
                </div>
            </div>
        </>
    );
}

export default Service;
